//import * as moment from 'moment';
// import 'moment/locale/zh-cn';
// moment.locale("zh-cn");
import "flatpickr/dist/flatpickr.css";
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n/zh";
ko.expressionRewriting["_twoWayBindings"].datePicker = true;
ko.bindingHandlers["datePicker"] = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var link = element;
        var value = ko.utils.unwrapObservable(valueAccessor()); //();
        //if (!value) return;
        var format = allBindingsAccessor().format || "YYYY-MM-DD"; // HH:mm
        var isShowTime = allBindingsAccessor().isShowTime || false;
        var flagDiv = allBindingsAccessor().flagDiv || undefined;
        // if (element instanceof HTMLInputElement)
        //     ko.bindingHandlers.value.init(element, () => date, allBindingsAccessor, null, null);
        // else
        //     ko.bindingHandlers.text.update(element, () => date, allBindingsAccessor, null, null);
        var d = flatpickr;
        var opt = {
            onChange: function (e, dateStr) {
                var writeValueToProperty = ko.expressionRewriting.writeValueToProperty || ko.expressionRewriting["Za"];
                //ko.expressionRewriting.writeValueToProperty(value, allBindingsAccessor, 'datePicker', e[0]);
                if (ko.isObservable(valueAccessor()))
                    valueAccessor()(dateStr);
                else
                    writeValueToProperty("", allBindingsAccessor, 'datePicker', dateStr); //=ko.observable(dateStr)
                console.log(dateStr);
                //  valueAccessor()(e[0]) //moment(r).format(format)  
            },
            locale: "zh",
            enableTime: isShowTime,
            appendTo: flagDiv
            //disableMobile: true 
        };
        if (value) {
            // let date = new Date(value)//moment(value)
            //  opt.defaultDate = date //.toDate(); 
            //ko.bindingHandlers.value.init(element, () => value, allBindingsAccessor, null, null);
        }
        flatpickr(element, opt);
    },
    update: function (element, valueAccessor, allBindingsAccessor) {
        var value = ko.utils.unwrapObservable(valueAccessor()); //();
        var fp = element["_flatpickr"];
        if (value) {
            fp.setDate(new Date(value));
        }
        else
            fp.setDate();
    }
};
